import ko from '@tko/build.knockout';
import _ from 'lodash';
import MenuIcons from '../../../../app/helpers/menu-icons';
import PermissionService from '../../../../services/permission.service';
import '../../../assurance/components/capture/capture';
import templateMarkup from 'raw-loader!./rooms-app-view.html';
import LoginService from "../../../../services/login.service";
import DataProvider from "../../../../app/data-framework/data-provider";

function RoomsAppView(params) {
  var self = this;
  self.initialize(params);
}

RoomsAppView.prototype = {
  initialize: function(params) {
    var self = this;

    self.dataProvider = DataProvider.getInstance();
    self.permissionService = new PermissionService(LoginService.userObject);
    self.app = self.dataProvider.getModuleDictionary().roomInsights;
    self.route = params.route;
    self.view = ko.pureComputed(function() { return self.route().view; });

    self.tabId = ko.pureComputed(function() { return self.route().tabId; });

    var appMenuItems = self.dataProvider.getListOfApps();

    var subModules = [{
        id: 'roomsDashboards',
        name: 'Dashboards',
        icon: MenuIcons.getDashboard(),
        url: '#rooms/dashboard',
        viewId: 'historical2roomboard',
        badge: undefined,
        views: []
      },
    ];
    
    let summaryViews = [
      { id: 'buildingUsage', url: '#rooms/dataset/buildingSummary', name: 'Building Usage', badge: 'beta'},
    ];


    if (self.permissionService.hasPermission(self.permissionService.ViewDatasetsPermission)) {
      subModules.push({ id: 'roomsSummaryViews', name: "Summary Views", icon: MenuIcons.getSummaryViews(), url: undefined, views: summaryViews});
    }

    if (self.permissionService.hasPermission(self.permissionService.ViewDatasetsPermission)) {
        subModules.push(
            {
              id: 'roomsDatasets',
              name: 'Datasets',
              icon: MenuIcons.getDatasets(),
              url: undefined,
              badge: undefined,
              views: [
                { id: 'workspaces', url: '#rooms/workspaces', name: 'Workspaces', badge: undefined },
                { id: 'bookings', url: '#rooms/bookings', name: 'Bookings', badge: undefined }
              ]
            }
        );
    }

    if (self.permissionService.hasPermission(self.permissionService.ReportsPermission)) { //UI-1218
      subModules.push({ id: 'roomsReports', name: "Reports", icon: MenuIcons.getReports(), url: '#rooms/reports', badge: undefined, views: [] });
    }

    //add settings to the end
    if (self.permissionService.hasPermission(self.permissionService.SettingsViewPermission)) {
      subModules.push({ id: 'roomsSettings', name: 'Settings', icon: MenuIcons.getSettings(), url: '#rooms/settings', badge: undefined, views: [] });
    }

    // this is only needed for testing out the new query engine in side-by-side mode, can be removed once testing is complete
    if (window.sessionStorage.getItem("feature.qe") !== null) {
      subModules.push({ id: 'qe', name: 'QE: ' + window.sessionStorage.getItem("feature.qe"), icon: 'fa fa-server', url: null, badge: 'beta', views: []});
    }

    self.appsMenu = ko.observableArray(appMenuItems);
    self.sideMenu = ko.observableArray(subModules);
  }
};

export default { template: templateMarkup, viewModel: RoomsAppView }
